module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.href) ? _c('a', {
    staticClass: "ed-btn-squared",
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled,
      "target": _vm.target,
      "rel": _vm.newRel
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.notification) ? _c('span', {
    staticClass: "ed-btn-squared__notification"
  }, [_vm._v("\n    " + _vm._s(_vm.notification) + "\n  ")]) : _vm._e()], 2) : _c('button', {
    staticClass: "ed-btn-squared",
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.notification) ? _c('span', {
    staticClass: "ed-btn-squared__notification"
  }, [_vm._v("\n    " + _vm._s(_vm.notification) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4fe9f2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/squaredButton/squaredButton.vue
// module id = 712
// module chunks = 42